import * as TYPES from 'remote/notifications/types'

export const TYPES_AKNOWLEDGED_ON_COMMENT_VISIT = [
  TYPES.ADD_THREAD_TO_NOTE,
  TYPES.MENTION_IN_COMMENT,
  TYPES.REPLY_TO_COMMENT,
]

export const filterAknowledgedOnCommentVisit = ({
  commentId,
}) => notification => {
  return (
    TYPES_AKNOWLEDGED_ON_COMMENT_VISIT.includes(notification.type) &&
    notification.metadata.get('commentId') === commentId
  )
}
